module.exports = __webpack_public_path__ + "static/media/confetti-narrow-2x.207ac29c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/confetti-narrow-2x.png
// module id = 105
// module chunks = 0